export default "__VITE_ASSET__BP0dqvrg__"